var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-grid"
  }, [_c('div', {
    staticClass: "form-column"
  }, [_c('label', [_vm._v(" Enter Email (Same As Registered In MyWhoosh) "), _c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter Your Email Used In Binance",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.binance_email
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:binance_email', $event.target.value);
      }
    }
  }), _vm.errors.binance_email ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.binance_email) + " ")]) : _vm._e()]), _c('label', [_vm._v(" Phone number "), _c('div', {
    staticClass: "phone-input-group"
  }, [_c('select', {
    staticClass: "country-select",
    domProps: {
      "value": _vm.selectedCountry
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('country-changed', $event.target.value);
      }
    }
  }, _vm._l(_vm.countries, function (country) {
    return _c('option', {
      key: country.code,
      domProps: {
        "value": country.code
      }
    }, [_vm._v(" " + _vm._s(country.emoji) + " +" + _vm._s(country.dialCode) + " ")]);
  }), 0), _c('input', {
    staticClass: "phone-input",
    class: {
      'is-invalid': _vm.phoneInputTouched && !_vm.isPhoneValid,
      'is-valid': _vm.phoneInputTouched && _vm.isPhoneValid
    },
    attrs: {
      "type": "tel",
      "placeholder": "Phone number",
      "required": ""
    },
    domProps: {
      "value": _vm.nationalPhoneNumber
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('phone-input', $event.target.value);
      }
    }
  })]), _vm.errors.phone_number ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.phone_number) + " ")]) : _vm._e(), _vm.phoneInputTouched && !_vm.isPhoneValid && !_vm.errors.phone_number ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" Please enter a valid phone number ")]) : _vm._e(), _vm.phoneInputTouched && _vm.isPhoneValid ? _c('small', {
    staticClass: "text-success"
  }, [_vm._v(" Valid phone number format ")]) : _vm._e()]), _c('label', [_vm._v(" Binance public wallet address / Id "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Wallet Address Or Id",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.wallet_address
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:wallet_address', $event.target.value);
      }
    }
  }), _vm.errors.wallet_address ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.wallet_address) + " ")]) : _vm._e()]), _c('label', {
    staticClass: "otp-wrapper"
  }, [_vm._v(" Phone OTP code "), _c('input', {
    attrs: {
      "name": "otp",
      "type": "text",
      "placeholder": "Enter OTP Code",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.phone_otp
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:phone_otp', $event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "otp-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isPhoneOTPRequested || !_vm.isPhoneValid
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('request-phone-otp');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.phoneOTPButtonText) + " ")]), _vm.errors.phone_otp ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.phone_otp) + " ")]) : _vm._e()]), _c('label', {
    staticClass: "otp-wrapper"
  }, [_vm._v(" Email OTP code "), _c('input', {
    attrs: {
      "name": "otp",
      "type": "text",
      "placeholder": "Enter OTP Code",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.email_otp
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:email_otp', $event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "otp-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isEmailOTPRequested
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('request-email-otp');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.emailOTPButtonText) + " ")]), _vm.errors.email_otp ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.email_otp) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "form-column"
  }, [_c('label', [_vm._v(" Passport Proof "), _c('small', {
    staticClass: "upload-info"
  }, [_vm._v("Maximum file size: 5MB (JPEG, PNG, JPG)")]), _c('div', {
    staticClass: "custom-upload"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "passportProof",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handlePassportUpload
    }
  }), _c('div', {
    staticClass: "upload-box"
  }, [_c('svg', {
    staticClass: "upload-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 20h14v-2H5v2zm7-18L5.33 11h4.17v4h4.99v-4h4.17L12 2z"
    }
  })]), _c('p', [_vm._v(" " + _vm._s(_vm.passportFileName || "Click to upload or drag & drop") + " ")])])]), _vm.errors.passport_proof ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.passport_proof) + " ")]) : _vm._e()]), _c('label', [_vm._v(" Binance account verification center screenshot "), _c('small', {
    staticClass: "upload-info"
  }, [_vm._v("Maximum 5 files, 5MB each")]), _c('div', {
    staticClass: "custom-upload"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "binanceScreenshot",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.handleBinanceScreenshotUpload
    }
  }), _c('div', {
    staticClass: "upload-box"
  }, [_c('svg', {
    staticClass: "upload-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 20h14v-2H5v2zm7-18L5.33 11h4.17v4h4.99v-4h4.17L12 2z"
    }
  })]), _c('p', [_vm._v(" " + _vm._s(_vm.binanceScreenshotFileNames.length > 0 ? ((_vm.binanceScreenshotFileNames.length) + " file(s) selected") : "Click to upload or drag & drop multiple files") + " ")])])]), _vm.errors.binance_screenshot ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.binance_screenshot) + " ")]) : _vm._e()]), _vm.binanceScreenshotFileNames.length > 0 ? _c('div', {
    staticClass: "selected-files"
  }, _vm._l(_vm.binanceScreenshotFileNames, function (fileName, index) {
    return _c('div', {
      key: index,
      staticClass: "file-item",
      class: {
        'has-error': _vm.getFileError(index)
      }
    }, [_c('div', {
      staticClass: "file-content"
    }, [_c('span', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(fileName))]), _vm.getFileError(index) ? _c('div', {
      staticClass: "file-error"
    }, [_vm._v(" " + _vm._s(_vm.getFileError(index)) + " ")]) : _vm._e()]), _c('button', {
      staticClass: "remove-file-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.removeBinanceFile(index);
        }
      }
    }, [_vm._v(" × ")])]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "terms-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "required": ""
    },
    domProps: {
      "checked": _vm.formData.terms_accepted
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('update:terms_accepted', $event.target.checked);
      }
    }
  }), _vm._m(0)]), _vm.errors.terms_accepted ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.errors.terms_accepted) + " ")]) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v(" I agree to the "), _c('a', {
    attrs: {
      "href": "https://www.mywhoosh.com/terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://www.mywhoosh.com/privacy-policy/",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])]);
}]

export { render, staticRenderFns }